module.exports = __webpack_public_path__ + "fonts/Lato-HairlineItalic.b4da0df6.woff";